import { CommonModule } from '@angular/common';
import { Component, computed, Input, input, ViewEncapsulation } from '@angular/core';

export type LoaderSize = 'sm' | 'lg';
export type LoaderColors = 'primary' | 'white' | 'danger';

@Component({
  selector: 'wfs-spinner-loader',
  templateUrl: './spinner-loader.component.html',
  styleUrls: ['./spinner-loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule]
})
export class SpinnerLoaderComponent {
  @Input() text = '';
  @Input() noContainer = false; // Comes with min-height by default
  extraPadding = input(false);
  absoluteCenter = input(false); // Used in Patient to center vertically
  @Input() isCentered = true;
  @Input() color: LoaderColors = 'primary';
  @Input() size: LoaderSize = 'lg';
  @Input() textOnLeft = false;

  readonly centeredLoaderClasses = computed(() => ({
    'absolute-center': this.absoluteCenter(),
    'py-5': this.extraPadding()
  }));
}
